import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState,
} from 'react'

import { usePackProductsProvider } from '~/providers/PackProductsProvider'

import { SerializedProduct } from '~/data/product-card-data'

const Context = createContext<UserSelectionProviderContext>(null)

export type UserSelection = Record<any, any>[]

export interface UserSelectionProviderContext {
  userSelection?: UserSelection
  setUserSelection?: Dispatch<SetStateAction<UserSelection>>
}

type SerializedProductKeys =
  | 'productName'
  | 'customizationSubtitle'
  | 'shopifyId'
  | 'slug'
  | 'availableForSale'
  | 'defaultVariant'
  | 'hasUpsales'
  | 'productType'
  | 'variants'
  | 'defaultVariant'

export interface UserSelectionProviderProps
  extends Pick<SerializedProduct, SerializedProductKeys>,
    Pick<SerializedProduct, 'media'> {
  children?: ReactNode | ReactNode[]
  isMultiBundle?: boolean
}

export function useUserSelectionProvider() {
  return useContext(Context)
}

function UserSelectionProvider({
  children,
  isMultiBundle,
}: UserSelectionProviderProps) {
  const { data } = usePackProductsProvider()

  const [userSelection, setUserSelection] = useState(
    data.map((tab, index) => {
      const product = tab?.[0]

      // defining default variants for customization products if needed
      const customizationEntries = product?.customizationProducts?.map(
        ({ productType, defaultVariant, required }) => [
          productType,
          required ? defaultVariant?.id : null,
        ],
      )
      return {
        isActive: isMultiBundle ? false : index === 0,
        productId: product?.shopifyId,
        variantId: product?.defaultVariant?.id,
        labelCustomization: null,
        labelCustomizationVariant: null,
        ...(customizationEntries
          ? Object.fromEntries(customizationEntries)
          : {}),
      }
    }),
  )

  return (
    <Context.Provider value={{ userSelection, setUserSelection }}>
      {children}
    </Context.Provider>
  )
}

export default UserSelectionProvider
